"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MatchingFormatGroup {
    constructor({ name, availableFormats, adminAvailableFormats, }) {
        this.toJSON = () => ({
            name: this.name,
            availableFormats: this.availableFormats,
            adminAvailableFormats: this.adminAvailableFormats,
        });
        this.name = name;
        this.availableFormats = availableFormats;
        this.adminAvailableFormats = adminAvailableFormats;
    }
}
MatchingFormatGroup.fromJSON = (json) => {
    const { name, availableFormats, adminAvailableFormats } = Object.assign({}, json);
    if (!!name && typeof name !== 'string')
        throw new Error('.name must be a string');
    if (!Array.isArray(availableFormats))
        throw new Error('.availableFormats must be an array');
    if (!!adminAvailableFormats && !Array.isArray(adminAvailableFormats))
        throw new Error('.adminAvailableFormats must be an array');
    return new MatchingFormatGroup({ name, availableFormats, adminAvailableFormats });
};
exports.default = MatchingFormatGroup;
